var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPivot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      stroke: oklch(0.707 0.022 261.325);\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2 3.17647L2 5.52941C2 6.17916 2.52672 6.70588 3.17647 6.70588L20.8235 6.70588C21.4733 6.70588 22 6.17916 22 5.52941V3.17647C22 2.52672 21.4733 2 20.8235 2L3.17647 2M2 3.17647C2 2.52672 2.52672 2 3.17647 2M2 3.17647L2 20.8235C2 21.4733 2.52672 22 3.17647 22H5.52941C6.17916 22 6.70588 21.4733 6.70588 20.8235V3.17647C6.70588 2.52672 6.17916 2 5.52941 2L3.17647 2M9 15C9 15 11.5 15 13 13C14.5 11 14.5 9 14.5 9",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPivot);
export default __webpack_public_path__ + "static/media/pivot.dc4e5c9462af9ec0f2bd47d749acbd14.svg";
export { ForwardRef as ReactComponent };